import { Skeleton } from "@mui/material";
import React from "react";

interface FieldsSkeletonProps {}

const FieldsSkeleton = (props: FieldsSkeletonProps) => {
  const renderFieldsSkeletons = () => {
    const skeletons = [];

    for (let i = 0; i < 20; i++) {
      skeletons.push(
        <Skeleton
          variant="rounded"
          height={72}
          className="dui-field-skeleton"
          key={i}
        />
      );
    }
    return skeletons;
  };
  return <div className="dui-fields-skeleton">{renderFieldsSkeletons()}</div>;
};

export default FieldsSkeleton;
